<template>
  <div class="mt-[14px] bg-[white] rounded-[12px] p-[24px]">
    <div class="flex justify-between">
      <div class="font-bold text-[18px]">ชั้น {{ tab }}</div>
      <!-- <div
        @click="updateMeterAll(ElectricityFee.map((data) => data.newElec))"
        :disabled="ElectricityFee.length < 1"
      >
        <vs-button>บันทึกทั้งหมด</vs-button>
      </div> -->
    </div>

    <div class="mt-[14px]">
      <vs-table>
        <template #thead>
          <vs-tr>
            <vs-th> เลขห้อง </vs-th>
            <vs-th> สถานะห้อง </vs-th>
            <vs-th> ชื่อผู้เช่า </vs-th>
            <vs-th> เลขมิเตอร์เดือนก่อนหน้า </vs-th>
            <vs-th> เลขมิเตอร์เดือนล่าสุด </vs-th>
            <vs-th> หน่วยที่ใช้ </vs-th>
            <vs-th> Action </vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr :key="i" v-for="(tr, i) in ElectricityFee" :data="tr">
            <vs-td>
              {{ tr.RoomNumber }}
            </vs-td>
            <vs-td>
              <div class="flex justify-start items-center">
                <div
                  class="pl-[12px] pr-[12px] pb-[4px] pt-[4px] rounded-[12px] text-center"
                  :class="
                    tr.user_sign_contract
                      ? 'text-[#1DC56A] bg-[#D8FAD5]'
                      : 'text-[#8396A6] bg-[#DEEAF5]'
                  "
                >
                  {{ tr.user_sign_contract ? "มีผู้เข้าพัก" : "ห้องว่าง" }}
                </div>
              </div>
            </vs-td>
            <vs-td>
              {{
                tr.user_sign_contract
                  ? (tr.user_sign_contract.users_permissions_user?.firstName || "") +
                    " " +
                    (tr.user_sign_contract.users_permissions_user?.lastName || "")
                  : ""
              }}
            </vs-td>
            <vs-td>
              <div>
                <div v-if="tr.electric_fees[1]">
                  <vs-input 
                    v-model="tr.electric_fees[1].electicUnit"
                    @blur="updatePreviousElectricfee(
                      tr.electric_fees[1].id,
                      tr.electric_fees[1].electicUnit,
                      calculateUsageMeter(tr.electric_fees[0].electicUnit, tr.electric_fees[1].electicUnit)
                    )"
                  >
                    <template #icon>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_3354_881"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="25"
                        >
                          <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_3354_881)">
                          <path
                            d="M11.5 6.5L15.25 10.5H13V16.5H10V10.5H7.75L11.5 6.5ZM5 18.5V20.5H18V18.5H5Z"
                            :fill="tab == 1 ? 'white' : '#003765'"
                          />
                        </g>
                      </svg>
                    </template>
                  </vs-input>
                </div>
                <div v-else>
                  <vs-input v-model="tr.previousElectricValue"
                    @blur="createPreviousMonthElectricfee(
                      tr.id,
                      tr.user_sign_contract ? tr.user_sign_contract.id : null,
                      tr.previousElectricValue
                    )">
                    <template #icon>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_3354_881"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="25"
                        >
                          <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_3354_881)">
                          <path
                            d="M11.5 6.5L15.25 10.5H13V16.5H10V10.5H7.75L11.5 6.5ZM5 18.5V20.5H18V18.5H5Z"
                            :fill="tab == 1 ? 'white' : '#003765'"
                          />
                        </g>
                      </svg>
                    </template>
                  </vs-input>
                </div>
              </div>
            </vs-td>
            <vs-td>
              <!-- current month's record is always created lazily by the backend -->
              <vs-input
                v-model="tr.electric_fees[0].electicUnit"
                @blur="updateElectfee(
                  tr.electric_fees[0].id,
                  tr.electric_fees[0].electicUnit,
                  calculateUsageMeter(tr.electric_fees[0].electicUnit, previousReading(tr))
                )"
              >
                <template #icon>
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_3354_881"
                      style="mask-type: alpha"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="25"
                    >
                      <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_3354_881)">
                      <path
                        d="M11.5 6.5L15.25 10.5H13V16.5H10V10.5H7.75L11.5 6.5ZM5 18.5V20.5H18V18.5H5Z"
                        :fill="tab == 1 ? 'white' : '#003765'"
                      />
                    </g>
                  </svg>
                </template>
              </vs-input>
            </vs-td>
            <vs-td>
              {{ calculateUsageMeter(tr.electric_fees[0].electicUnit, previousReading(tr)) }}
            </vs-td>
            <vs-td>
              <div>
                <vs-button
                  :disabled="tr.electric_fees[0].electicUnit === null || tr.electric_fees[0].electicUnit === undefined || tr.electric_fees[0].electicUnit === ''"
                  @click="
                    updateElectfee(
                      tr.electric_fees[0].id,
                      tr.electric_fees[0].electicUnit,
                      calculateUsageMeter(tr.electric_fees[0].electicUnit, previousReading(tr))
                    )
                  "
                  >บันทึก</vs-button
                >
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    tab: { type: { String } },
    id: { type: { String } },
  },
  data() {
    return {
      ElectricityFee: [],
      electicUnit: 0,
      floor: [],
      code: 0,
      text: "",
      month: "",
      year: "",
      importExcel: [],
      savedScrollPosition: 0, 
    };
  },
  created() {
    const loading = this.$vs.loading({});
    setTimeout(() => {
      loading.close();
    }, 1000);
  },
  mounted() {
    const dateStr = new Date().toISOString().substr(0, 7);
    const [y, m] = dateStr.split("-");
    this.month = m;
    this.year = y;
    this.getElectricityFee(this.id, this.month, this.year);
  },
  methods: {
    // Helper method to calculate usage meter
    calculateUsageMeter(currentReading, previousReading) {
      // Ensure readings are treated as numbers
      const current = Number(currentReading) || 0;
      const previous = Number(previousReading) || 0;
      
      // Calculate usage and ensure it's not negative
      return Math.max(0, current - previous);
    },
    saveScrollPosition() {
    this.savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  },
  
  // Helper method to restore scroll position
  restoreScrollPosition() {
    if (this.savedScrollPosition !== undefined) {
      // Use setTimeout to ensure DOM is updated first
      this.$nextTick(() => {
        setTimeout(() => {
          window.scrollTo(0, this.savedScrollPosition);
        }, 100);
      });
    }
  },

  // 3. UPDATE getElectricityFee METHOD:
  getElectricityFee(id, m, y, preserveScroll = false) {
    // Save scroll position if we want to preserve it
    if (preserveScroll) {
      this.saveScrollPosition();
    }
    
    console.log("month", m);
    console.log("year", y);
    this.ElectricityFee = [];
    const loading = this.$vs.loading();
    fetch(
      `https://api.resguru.app/api/getelectriclist?buildingid=${this.$store.state.building}&buildingFloor=${id}&month=${m}&year=${y}`
    )
      .then((response) => response.json())
      .then((resp) => {
        console.log("Return from getElecFeeRoom()", resp.data);

        // Backend already guarantees electric_fees[0] is this month's record
        // (created blank if nobody has read it yet). electric_fees[1] is
        // last month's record if one exists in the DB - it often won't
        // right after migrating from the old overwrite-in-place system, so
        // seed an editable baseline from the contract's starting reading.
        const processedData = resp.data.map(item => {
          item.electric_fees = item.electric_fees || [];
          // Defensive fallback in case the backend's guarantee above ever
          // doesn't hold - avoids crashing the whole page on a bad record.
          if (!item.electric_fees[0]) {
            item.electric_fees[0] = { id: null, electicUnit: null };
          }
          if (!item.electric_fees[1]) {
            item.previousElectricValue = item.user_sign_contract?.startElectric || 0;
          }
          return item;
        });

        if (this.code == 8) {
          this.ElectricityFee = processedData.filter((item) =>
            item.RoomNumber.toLowerCase().includes(this.text.toLowerCase())
          );
        } else {
          this.ElectricityFee = processedData;
        }

        // Restore scroll position if preserved
        if (preserveScroll) {
          this.restoreScrollPosition();
        }
      })
      .catch((error) => {
        const errorMessage = this.$errMsg(error, 'โหลดข้อมูลค่าไฟ');
        this.$showNotification("danger", errorMessage);
      })
      .finally(() => {
        loading.close();
      });
  },

  // Returns the previous month's meter reading for a room: last month's
  // actual fee record if one exists, otherwise whatever's currently in the
  // editable previousElectricValue field (seeded from the contract's
  // starting reading, but staff can correct it - see
  // createPreviousMonthElectricfee).
  previousReading(tr) {
    if (tr.electric_fees[1]) {
      return tr.electric_fees[1].electicUnit;
    }
    return tr.previousElectricValue || 0;
  },

  getPreviousMonthYear() {
    const month = parseInt(this.month, 10);
    const year = parseInt(this.year, 10);
    if (month === 1) {
      return { previousMonth: 12, previousYear: year - 1 };
    }
    return { previousMonth: month - 1, previousYear: year };
  },

  // Creates a single, correctly-tagged record for last month when no such
  // record exists yet (new tenancy, or a room whose old data predates the
  // billMonth/billYear tagging). Unlike the old flow this never creates a
  // duplicate current-month record - that one is already guaranteed by
  // the backend.
  createPreviousMonthElectricfee(roomId, contractId, previousMeterUnit) {
    if (!roomId || !contractId || previousMeterUnit === undefined || previousMeterUnit === null || previousMeterUnit === '') {
      console.warn("Cannot create previous month electric fee: Missing required data");
      this.$showNotification("warning", "กรุณาใส่ค่าไฟฟ้าเดือนก่อนหน้าก่อนบันทึก");
      return;
    }

    this.saveScrollPosition();
    const loading = this.$vs.loading();
    const numericValue = Math.max(0, Number(previousMeterUnit) || 0);
    const { previousMonth, previousYear } = this.getPreviousMonthYear();

    axios
      .post(`https://api.resguru.app/api/electric-fees/`, {
        data: {
          room: roomId,
          user_sign_contract: contractId,
          billMonth: previousMonth,
          billYear: previousYear,
          electicUnit: numericValue,
          usageMeter: 0,
        },
      })
      .then(() => {
        this.$showNotification("#3A89CB", "บันทึกค่าไฟฟ้าเดือนก่อนหน้าสำเร็จ");
        this.getElectricityFee(this.id, this.month, this.year, true);
      })
      .catch((error) => {
        const errorMessage = this.$errMsg(error, 'บันทึกค่าไฟเดือนก่อนหน้า');
        this.$showNotification("danger", errorMessage);
      })
      .finally(() => {
        loading.close();
      });
  },

  // 5. UPDATE updatePreviousElectricfee METHOD:
  updatePreviousElectricfee(electricFeeId, electricUnit, currentUsageMeter) {
    // Skip if invalid data
    if (!electricFeeId || !electricUnit) {
      console.warn("Cannot update previous month electric fee: Missing required data");
      return;
    }
    
    // Save scroll position before API call
    this.saveScrollPosition();
    
    const loading = this.$vs.loading();
    
    // Convert to number and ensure it's not negative
    const numericValue = Math.max(0, Number(electricUnit));
    
    // Update the previous month electric fee
    axios
      .put(`https://api.resguru.app/api/electric-fees/${electricFeeId}`, {
        data: {
          electicUnit: numericValue,
        },
      })
      .then(() => {
        // Find the room data for this electric fee
        const roomData = this.ElectricityFee.find(item => 
          item.electric_fees[1] && item.electric_fees[1].id === electricFeeId
        );
        
        // If there is a current month reading, update its usage calculation
        if (roomData && roomData.electric_fees[0]) {
          // Get current month reading
          const currentMeterReading = Number(roomData.electric_fees[0].electicUnit);
          
          // Calculate new usage for current month based on current reading minus updated previous month value
          const newUsage = Math.max(0, currentMeterReading - numericValue);
          
          return axios.put(`https://api.resguru.app/api/electric-fees/${roomData.electric_fees[0].id}`, {
            data: {
              usageMeter: newUsage,
            },
          });
        }
      })
      .catch((error) => {
        const errorMessage = this.$errMsg(error, 'บันทึกค่าไฟเดือนก่อนหน้า');
        this.$showNotification("danger", errorMessage);
      })
      .finally(() => {
        loading.close();
        this.$showNotification("#3A89CB", "บันทึกค่าไฟเดือนก่อนหน้าสำเร็จ");
        // Refresh the data to show the updated record but preserve scroll position
        this.getElectricityFee(this.id, this.month, this.year, true);
      });
  },

  // 7. UPDATE updateElectfee METHOD:
  updateElectfee(electFeeId, electicUnit, usageMeter) {
    // Skip if empty values
    if (!electicUnit) {
      return;
    }
    
    // Save scroll position before API call
    this.saveScrollPosition();
    
    // Ensure numeric values
    const numericElectricUnit = Number(electicUnit) || 0;
    // Ensure usageMeter is not negative
    const numericUsageMeter = Math.max(0, Number(usageMeter) || 0);
    
    console.log("Updating electric fee:", {
      electFeeId,
      electicUnit: numericElectricUnit,
      usageMeter: numericUsageMeter
    });
    
    const loading = this.$vs.loading();
    axios
      .put(`https://api.resguru.app/api/electric-fees/${electFeeId}`, {
        data: {
          electicUnit: numericElectricUnit,
          usageMeter: numericUsageMeter,
        },
      })
      .then((resp) => {})
      .catch((error) => {
        const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
        this.$showNotification("danger", errorMessage);
      })
      .finally(() => {
        loading.close();
        this.$showNotification("#3A89CB", "แก้ไขค่าไฟสำเร็จ");
        // Refresh data but preserve scroll position
        this.getElectricityFee(this.id, this.month, this.year, true);
      });
  },
    
    updateMeterAll(newElecArray) {
      if (this.ElectricityFee.length > 0) {
        const loading = this.$vs.loading();
        
        // Create a promise array to track all updates
        const updatePromises = [];
        
        this.ElectricityFee.forEach((data, i) => {
          console.log("Processing room data:", i, data);
          
          if (data.electric_fees[0] && data.electric_fees[0].electicUnit) {
            // Calculate usage meter based on whether there's a previous reading
            let usageMeter = 0;
            if (data.electric_fees[1]) {
              usageMeter = Math.max(0, Number(data.electric_fees[0].electicUnit) - Number(data.electric_fees[1].electicUnit));
            } else if (data.previousElectricValue) {
              usageMeter = Math.max(0, Number(data.electric_fees[0].electicUnit) - Number(data.previousElectricValue));
            } else {
              usageMeter = Number(data.electric_fees[0].electicUnit);
            }
            
            // Add promise to array
            updatePromises.push(
              axios.put(
                `https://api.resguru.app/api/electric-fees/${data.electric_fees[0].id}`,
                {
                  data: {
                    electicUnit: Number(data.electric_fees[0].electicUnit),
                    usageMeter: usageMeter
                  },
                }
              )
            );
          } else if (data.newElec) {
            // Calculate usage for new entries
            let usageMeter = 0;
            if (data.previousElectricValue) {
              usageMeter = Math.max(0, Number(data.newElec) - Number(data.previousElectricValue));
            } else {
              usageMeter = Number(data.newElec);
            }
            
            // Create new electric fee if we have the required data
            if (data.id && data.user_sign_contract && data.user_sign_contract.id) {
              updatePromises.push(
                axios.post(`https://api.resguru.app/api/electric-fees/`, {
                  data: {
                    room: data.id,
                    user_sign_contract: data.user_sign_contract.id,
                    electicUnit: Number(data.newElec),
                    usageMeter: usageMeter,
                  },
                })
              );
            }
          }
        });
        
        // Wait for all updates to complete
        Promise.all(updatePromises)
          .then(() => {
            this.$showNotification("#3A89CB", "แก้ไขค่าไฟทั้งหมดสำเร็จ");
            this.getElectricityFee(this.id, this.month, this.year);
          })
          .catch((error) => {
            const errorMessage = this.$errMsg(error, 'บันทึกข้อมูลค่าไฟ');
            this.$showNotification("danger", errorMessage);
          })
          .finally(() => {
            loading.close();
          });
      }
    },
    
    filterData(text, code) {
      this.text = text;
      console.log("Filtering by text:", text);
      
      if (text === "") {
        // If text is empty, reset to full data
        this.getElectricityFee(this.id, this.month, this.year);
      } else {
        // Filter the current dataset
        this.ElectricityFee = this.ElectricityFee.filter((item) =>
          item.RoomNumber.toLowerCase().includes(text.toLowerCase())
        );
      }
      
      // Handle backspace code (code 8)
      if (code == 8) {
        this.code = 8;
        this.getElectricityFee(this.id, this.month, this.year);
      }
    },
  },
};
</script>